import React from 'react';
import { CTAButton } from './CTAButton';
import { Coffee, ShoppingBag, Check } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-12 bg-gradient-to-b from-rose-50 to-white" data-id="element-66">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-67">
        <div className="max-w-5xl mx-auto" data-id="element-68">
          <div className="text-center mb-8" data-id="element-69">
            <h2 className="text-3xl md:text-4xl font-bold text-warm-900 mb-4" data-id="element-70">
              La inversión{' '}
              <span className="text-rose-500 font-serif italic" data-id="element-71">
                (ridículamente accesible)
              </span>
            </h2>
            <p className="text-lg text-warm-600" data-id="element-72">
              Menos de lo que gastas en un café, pero con resultados que duran.
            </p>
          </div>

          {/* Pricing Card */}
          <div className="max-w-2xl mx-auto mb-6" data-id="element-73">
            <div className="bg-white p-6 rounded-2xl shadow-xl border-2 border-rose-100 relative overflow-hidden" data-id="element-74">
              <div className="absolute top-0 right-0 bg-rose-500 text-white text-xs font-bold px-4 py-2 rounded-bl-lg" data-id="element-75">
                OFERTA ESPECIAL
              </div>

              <h3 className="text-2xl font-bold text-warm-900 mb-4 mt-4" data-id="element-76">
                Guía Completa Digital
              </h3>

              {/* Product Image Inside Card */}
              <div className="mb-4 rounded-xl overflow-hidden max-w-sm mx-auto" data-id="element-77">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qnmiVKwMDLX51UdvezczkV/ebook_chamba.png" alt="Chamba Digital para Mexicanas" className="w-full" data-id="element-78" />
              </div>

              <div className="mb-4" data-id="element-79">
                <div className="flex items-center gap-3 mb-1 justify-center" data-id="element-80">
                  <span className="text-lg text-warm-400 line-through" data-id="element-81">
                    $25.00
                  </span>
                  <span className="text-sm font-semibold text-rose-600 bg-rose-50 px-2 py-1 rounded" data-id="element-82">
                    68% OFF
                  </span>
                </div>
                <div className="text-4xl font-bold text-rose-600 font-serif text-center" data-id="element-83">
                  $7.99{' '}
                  <span className="text-lg font-normal text-warm-500" data-id="element-84">USD</span>
                </div>
                <p className="text-sm text-warm-500 mt-1 text-center" data-id="element-85">
                  Pago único • Acceso inmediato
                </p>
              </div>

              <ul className="space-y-2 mb-6 text-warm-700" data-id="element-86">
                <li className="flex items-start gap-3" data-id="element-87">
                  <Check className="w-5 h-5 text-rose-500 shrink-0 mt-0.5" data-id="element-88" />
                  <span data-id="element-89">7 Chambas Digitales explicadas paso a paso</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-90">
                  <Check className="w-5 h-5 text-rose-500 shrink-0 mt-0.5" data-id="element-91" />
                  <span data-id="element-92">Guiones de WhatsApp listos para copiar</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-93">
                  <Check className="w-5 h-5 text-rose-500 shrink-0 mt-0.5" data-id="element-94" />
                  <span data-id="element-95">Checklist de Seguridad anti-estafas</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-96">
                  <Check className="w-5 h-5 text-rose-500 shrink-0 mt-0.5" data-id="element-97" />
                  <span data-id="element-98">Lista de apps y plataformas para México</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-99">
                  <Check className="w-5 h-5 text-rose-500 shrink-0 mt-0.5" data-id="element-100" />
                  <span data-id="element-101">Acceso de por vida</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bonus Section */}
          <div className="max-w-2xl mx-auto space-y-4 mb-6" data-id="element-102">
            {/* Bonus 1 - Reto 7 Días */}
            <div className="bg-gradient-to-br from-pink-100 to-rose-100 p-6 rounded-2xl shadow-lg border-2 border-pink-300 relative overflow-hidden" data-id="element-103">
              <div className="absolute top-0 right-0 bg-gradient-to-r from-pink-500 to-rose-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-104">
                BONO GRATIS
              </div>

              <div className="flex flex-col md:flex-row gap-4 items-center" data-id="element-105">
                {/* Bonus Image */}
                <div className="w-32 shrink-0" data-id="element-106">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qqm9YuR5FwCXmLbe9tYpfq/image-d455b801-aabd-4d0f-b6a8-e95631692e57.png" alt="Reto 7 Días" className="w-full rounded-xl shadow-md" data-id="element-107" />
                </div>

                {/* Bonus Content */}
                <div className="flex-1" data-id="element-108">
                  <h3 className="text-lg font-bold text-warm-900 mb-1" data-id="element-109">
                    🎁 Bono 1: Reto 7 Días
                  </h3>
                  <p className="text-sm font-semibold text-rose-600 mb-2" data-id="element-110">
                    De Cero a Tu Primer Plan de Chamba Digital
                  </p>

                  <div className="flex items-center gap-2 mb-2" data-id="element-111">
                    <span className="text-sm text-warm-400 line-through" data-id="element-112">
                      $15.50
                    </span>
                    <span className="text-lg font-bold text-green-600" data-id="element-113">
                      Hoy gratis
                    </span>
                  </div>

                  <p className="text-xs text-warm-600 italic" data-id="element-114">
                    Plan de acción de 7 días para elegir tu chamba, definir
                    precios y conseguir tus primeros clientes.
                  </p>
                </div>
              </div>
            </div>

            {/* Bonus 2 - Cobra Sin Pena */}
            <div className="bg-gradient-to-br from-pink-100 to-rose-100 p-6 rounded-2xl shadow-lg border-2 border-pink-300 relative overflow-hidden" data-id="element-115">
              <div className="absolute top-0 right-0 bg-gradient-to-r from-pink-500 to-rose-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-116">
                BONO GRATIS
              </div>

              <div className="flex flex-col md:flex-row gap-4 items-center" data-id="element-117">
                {/* Bonus Image */}
                <div className="w-32 shrink-0" data-id="element-118">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1cdaaXnpk2haDKysmUvyTW/image-e3180bcc-1883-447b-8d41-423697ede9f5.png" alt="Cobra Sin Pena" className="w-full rounded-xl shadow-md" data-id="element-119" />
                </div>

                {/* Bonus Content */}
                <div className="flex-1" data-id="element-120">
                  <h3 className="text-lg font-bold text-warm-900 mb-1" data-id="element-121">
                    🎁 Bono 2: Cobra Sin Pena
                  </h3>
                  <p className="text-sm font-semibold text-rose-600 mb-2" data-id="element-122">
                    Mini guía práctica para ponerle precio a tu chamba digital
                  </p>

                  <div className="flex items-center gap-2 mb-2" data-id="element-123">
                    <span className="text-sm text-warm-400 line-through" data-id="element-124">
                      $12.00
                    </span>
                    <span className="text-lg font-bold text-green-600" data-id="element-125">
                      Hoy gratis
                    </span>
                  </div>

                  <p className="text-xs text-warm-600 italic" data-id="element-126">
                    Aprende a calcular precios, negociar sin culpa y cobrar con
                    seguridad. Incluye guiones listos para WhatsApp.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Price Summary Box - After All Bonuses */}
          <div className="max-w-2xl mx-auto" data-id="element-127">
            <div className="bg-white p-6 rounded-2xl shadow-xl border-2 border-rose-200" data-id="element-128">
              <div className="bg-gradient-to-br from-warm-50 to-rose-50 p-4 rounded-xl border-2 border-rose-200 mb-4" data-id="element-129">
                <div className="space-y-2 mb-3" data-id="element-130">
                  <div className="flex justify-between items-center text-sm" data-id="element-131">
                    <span className="text-warm-700" data-id="element-132">Guía Completa Digital</span>
                    <span className="text-warm-400 line-through" data-id="element-133">$25.00</span>
                  </div>
                  <div className="flex justify-between items-center text-sm" data-id="element-134">
                    <span className="text-warm-700" data-id="element-135">Bono #1: Reto 7 Días</span>
                    <span className="text-warm-400 line-through" data-id="element-136">$15.50</span>
                  </div>
                  <div className="flex justify-between items-center text-sm" data-id="element-137">
                    <span className="text-warm-700" data-id="element-138">
                      Bono #2: Cobra Sin Pena
                    </span>
                    <span className="text-warm-400 line-through" data-id="element-139">$12.00</span>
                  </div>
                </div>

                <div className="border-t-2 border-rose-300 pt-3" data-id="element-140">
                  <div className="flex justify-between items-center mb-1" data-id="element-141">
                    <span className="text-lg font-bold text-warm-900" data-id="element-142">
                      Total Hoy:
                    </span>
                    <div className="text-right" data-id="element-143">
                      <div className="text-sm text-warm-400 line-through" data-id="element-144">
                        $52.50
                      </div>
                      <div className="text-3xl font-bold text-rose-600" data-id="element-145">
                        $7.99
                      </div>
                    </div>
                  </div>
                  <p className="text-xs text-center text-warm-600 italic" data-id="element-146">
                    Ahorras $44.51 • Oferta válida solo por hoy
                  </p>
                </div>
              </div>

              <CTAButton fullWidth href="https://www.arisalabs.com/cart/49570543010069:1" trackLead={true} data-id="element-147">
                Obtener Todo por $7.99
              </CTAButton>

              <div className="mt-4 pt-4 border-t border-warm-100" data-id="element-148">
                <p className="text-xs text-center text-warm-500" data-id="element-149">
                  🔒 Pago 100% seguro • Entrega inmediata por email
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}